/**
 * Selector de talla, color o medida en la ficha (VAR-01).
 *
 * Cada variante es un producto con su propia URL, asi que elegir una es
 * NAVEGAR a su ficha: por eso son `<Link>` y no botones con estado. Se puede
 * abrir una talla en otra pestana, compartir el enlace de la talla exacta, y un
 * buscador encuentra cada una por separado (SEO-01).
 *
 * Una variante agotada no se esconde ni se bloquea: se marca. Entrar a su ficha
 * es la forma de consultar por WhatsApp cuando vuelve.
 */
import { Link } from 'react-router-dom';

import type { VarianteProducto } from '@bandu/compartido';

import { rutas } from '../../utilidades/rutas';
import { MANTENER_POSICION } from '../diseno/VolverArriba';

export interface SelectorVariantesProps {
  variantes: VarianteProducto[];
  /** Codigo de la variante cuya ficha se esta viendo. */
  skuActual: string;
}

export function SelectorVariantes({ variantes, skuActual }: SelectorVariantesProps) {
  // Con una sola no hay nada que elegir.
  if (variantes.length < 2) return null;

  return (
    <nav className="variantes" aria-label="Otras opciones de este producto">
      <p className="variantes-rotulo">Elige una opción</p>
      <ul className="variantes-lista">
        {variantes.map((variante) => {
          const actual = variante.sku === skuActual;
          const agotada = variante.estadoStock === 'agotado';
          const clases = ['variante', actual ? 'actual' : '', agotada ? 'agotada' : '']
            .filter((clase) => clase.length > 0)
            .join(' ');

          return (
            <li key={variante.sku}>
              <Link
                className={clases}
                to={rutas.producto(variante.slug)}
                aria-current={actual ? 'true' : undefined}
                // Cambiar de talla no es ir a otra pagina: se queda donde estaba.
                state={MANTENER_POSICION}
              >
                {variante.etiqueta}
                {agotada ? <span className="solo-lectores"> (sin stock)</span> : null}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
